<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
            <Form ref="formInline" :model="formInline" inline class="form-list"
                  :label-width="100" label-position="right">
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="人员姓名:" prop="workerName" :label-width="78">
                            <Input v-model="formInline.workerName" placeholder="请输入人员姓名"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="身份证号:" prop="idCardNum">
                            <Input v-model="formInline.idCardNum" placeholder="请输入身份证号"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="岗位类型:" prop="manageType " :label-width="78">
                            <Select v-model="formInline.manageType" filterable transfer placeholder="请选择岗位类型">
                                <Option v-for="(item,index) in manageTypeArr" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="6" class="high-search">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>
                    <Col span="6">
                        <FormItem label="项目名称: "  :label-width="78">
                            <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="所属企业:" prop="corpName">
                            <Input v-model="formInline.corpName" placeholder="请输入所属企业"></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="人员状态：" prop="workerStatus">
                            <RadioGroup v-model="formInline.workerStatus">
                                <Radio :label="1">在岗</Radio>
                                <Radio :label="2">在册</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16" v-show='open'>

                    <Col span="6">
                        <FormItem label="项目所在地:" :label-width="78">
                            <place-select v-model="formInline.areaCode"></place-select>
                        <!--              <Select v-model="formInline.areaCode">-->
                        <!--                <Option v-for="item in area" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                        <!--              </Select>-->
                        </FormItem>
                    </Col>
                </Row>
            </Form>
           <!-- <div style="margin-bottom: 24px;">
                <Button :loading="eLoading" type="primary" @click="handleExport" icon="ios-exit-outline">导出</Button>
            </div>-->
             <Table border :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{row,index}" slot="image">
                    <div style="padding:12px;">
                        <span v-if="row.headImage" class="head-wrap"><img :src="row.headImage" style="width:100%;"></span>
                        <Avatar v-else size="50" icon="ios-person" ></Avatar>
                    </div>

                </template>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" type="text" size="small" @click="handleDeal('personnelDetail','',row.workerId,'person')">人员详情</span>&nbsp;&nbsp;
                    <span class="pointer" type="text" size="small" @click="handleDeal('checking-inDetail',row.projectWorkerId,row.workerId,'checking')">考勤详情</span>
                </template>
            </Table>
             <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>

    </div>
</template>
<style  scoped>
    .pointer{
        color: #3399FF;
        cursor: pointer;
    }
</style>
<script>
    import {mapState,mapGetters} from 'vuex';
    import tableMixin from '@/components/tableMixin';
    export default {
        mixins: [tableMixin],
        data(){
            return {
                eLoading: false,
                open: false,
                formInline:{
                    projectName:'',
                    workerName:'',
                    idCardNum:'',
                    workRole:10,
                    manageType:'',
                    corpName:'',
                    workerStatus: 2,
                    areaCode: localStorage.getItem('tenantAreaCode'),
                },
                tableData:[],
                 tableColumns:[
                    {
                        title: '序号',
                        type: 'index',
                        width: 70,
                        align: 'center'
                    },
                    {
                        title: '姓名',
                        key: 'workerName',
                        minWidth:80,
                        align: 'center'
                    },
                    {
                        title: '身份证号',
                        key: 'idCardNumber',
                        minWidth:150,
                        align: 'center'
                    },
                    {
                        title: '籍贯',
                        key: 'nativePlace',
                        minWidth:150,
                        align: 'center'
                    },
                    {
                        title: '性别',
                        key:'gender',
                        align: 'center',
                         minWidth:100,
                    },
                    {
                        title:'年龄',
                        key:'age',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title:'民族',
                        key:'nation',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title:'联系电话',
                        key:'cellPhone',
                        minWidth:150,
                        align:'center'
                    },
                    {
                        title:'所属企业',
                        key:'corpName',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title:'所在项目',
                        key:'projectName',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title:'所在班组',
                        key:'teamName',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title:'岗位类型',
                        key:'manageTypeName',
                        minWidth:100,
                        align:'center'
                    },
                    {
                        title: '头像',
                        slot: 'image',
                        align: 'center',
                        width: 200
                    },
                    {
                        title: '操作',
                        slot: 'action',
                        fixed: 'right',
                        align: 'center',
                        width: 200
                    }
                 ],
                exportData:{
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.areaCode,
                },
                manageTypeArr:[]
            };
        },
        computed:{
            ...mapState(['area']),
            ...mapGetters(['workerType']),
        },
        created(){
            this.$route.query.areaCode && (this.formInline.areaCode = this.$route.query.areaCode)
            this.formInline.workerStatus = this.$route.query.workerStatus ? this.$route.query.workerStatus : 2
        },
        mounted(){
            this.getMerageType();

        },
        watch: {

        },
        methods: {
                     //获取工程师类型得数据
            getMerageType(){
                 this.axios({
                    method: 'get',
                    url:'/worker/sx/allManage/type',
                 }).then(res=>{
                     console.log(res.data)
                     if(res.data.success){
                         res.data.data.unshift({code:'',name:'全部岗位类型'})
                         this.manageTypeArr = res.data.data.map((item)=>{
                             return {
                                 value:item.code,
                                 label:item.name
                             }

                         });
                     }
                 })
            },
            handleReset() {
                this.page = 1
                this.formInline = {
                    workerName:'',
                    idCardNum:'',
                    workRole:10,
                    manageType:'',
                    corpName:'',
                    workerStatus:1,
                    areaCode: localStorage.getItem('tenantAreaCode'),
                }
                this.getTableData();
            },
            //导出
            handleExport(){
                let param={
                    ...this.formInline,
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.formInline.areaCode,
                };
                this.eLoading = true;
                this.axios({
                    method: 'post',
                    url:'/worker/sx/exportManage',
                    responseType:'arraybuffer',
                    data: param,
                }).then( (response)=> {
                    this.eLoading = false;
                    this.common.download(response,'关键岗位人员.xls','application/vnd.ms-excel');
                }).catch(() => {
                    this.eLoading = false;
                });
            },
            /*处理操作*/
            handleDeal(name,uuid,workerId,type){
                if(type === 'person'){
                    this.$router.push({
                        name: name,
                        query: {
                            workerId:workerId
                        }
                    });

                }else {
                    this.$router.push({
                        name: name,
                        query: {
                            projectWorkerId:uuid,
                            workerId: workerId
                        }
                });
                }

            },
            /*获取表格数据*/
            getTableData(){
                let param={
                    ...this.formInline,
                    size:this.pageSize,
                    current:this.page,
                    areaCode:this.formInline.areaCode,
                };
                this.exportData=param;
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/worker/sx/pageList',
                    data:param
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total;
                        this.tableData=response.data.data.records;
                    }
                }).catch( ()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>

